import { WebMessenger as HostWebMessenger, setUp as originalSetup } from './web-messenger';

export function setUp() {
    const globalVarName = window.BookboostWebMessengerObject;
    if (!globalVarName || !window[globalVarName]) {
        console.error('Bookboost Host Error: must use loader script');
        return;
    }
    const options = window[globalVarName].o;
    delete window[globalVarName].o;

    if (!options) {
        console.error('Bookboost Host Error: no options provided');
        return;
    }

    // Initializes HostWebMessenger so we can call init
    originalSetup();

    // Decorate the original handler assigned in originalSetup()
    const originalOnWebMessengerReady = window.__onWebMessengerFrameReady__;
    window.__onWebMessengerFrameReady__ = function(FrameWebMessenger) {
        // FrameWebMessenger is the module 'frame/js/bookboost-web-messenger.js'

        function isEventCommand(command) {
            const [type] = command;
            return type === 'on' || type === 'off';
        }

        const queue = window[globalVarName].q;
        // Consume all event commands since they could be triggered during init
        for (let i = 0; i < queue.length;) {
            const command = queue[i];
            if (isEventCommand(command)) {
                FrameWebMessenger.command(...command);
                queue.splice(i, 1);
            } else {
                i++;
            }
        }

        // Replace implementation so that event commands are executed directly.
        window[globalVarName].f = function(...command) {
            if (isEventCommand(command)) {
                FrameWebMessenger.command(...command);
            } else {
                queue.push(command);
            }
        };
        // Delete queue property since it is no longer needed.
        delete window[globalVarName].q;

        // This calls onWebMessengerReady in 'web-messenger.js'
        originalOnWebMessengerReady(FrameWebMessenger);

        // Called when web messenger has initialized and its safe to execute commands
        FrameWebMessenger.on('ready', onReady);
        function onReady() {
            FrameWebMessenger.off('ready', onReady);

            // Execute remaining commands now when the web messenger has been initialized
            for (const command of queue) {
                FrameWebMessenger.command(...command);
            }

            // Finally, replace implementation so that all commands are executed directly
            window[globalVarName].f = function (...command) {
                FrameWebMessenger.command(...command);
            };
        }
    };

    // HostWebMessenger is the skeleton available before frame has loaded.
    // Calling init will load the frame and call __onWebMessengerFrameReady__
    // when it is loaded.
    HostWebMessenger.init(options);
}
